import styled from 'styled-components'
import Button from 'antd/lib/button'
import Input from 'antd/lib/input'
import Search from 'antd/lib/auto-complete'
import { GRAY_DARK, RED, WHITE, GRAY_LIGHTEST, BLUE, GRAY_ANTDESIGN } from '../../../theme/colors'

interface DivProps {
  highlight?: boolean
}

export const Container = styled.div`
  background-color: ${WHITE};
  display: inline-flex;
  flex-direction: column;
  margin-right: 20px;
  flex: 2;
  max-width: 56%;
  &:last-child {
    margin: 0;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    padding: 0 20px;
  }
  @media (max-width: 320px) {
     padding: 0 10px;
  }
`

export const MainContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 0 28px;
  max-width: 1016px;
  flex-direction: row;
  align-items: flex-start;
  margin: 0 auto;
  font-family: "Avenir Next";
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0 4px;
  }
`

export const Label = styled.div`
  display: flex;
  color: ${GRAY_DARK};
  font-size: 14px;
  margin-bottom: 6px;
  color: #625F5F;
  font-weight: 600;
  &.space-y {
    margin-bottom: 18px;
  }
  span.footnote {
    color: #302628;
    font-weight: 400;
    font-size: 13px;
    line-height: 20.15px;
  }
  span.optional {
    flex: 1;
    margin-left: 10px;
    padding: 2px 8px;
    border-radius: 4px;
    background: #F7F7F7;
    font-size: 12px;
    line-height: 19px;
    font-weight: 500;
    color: #5F6062;
  }
  span.more-detail {
    flex: 1;
    font-size: 13px;
    font-weight: 600;
    line-height: 20.15px;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    &.space-y {
      margin-bottom: 12px;
    }
    span.optional {
      font-size: 11px;
      margin-left: 0px;
    }
  }
`

export const CounterLabel = styled.div`
  display: flex;
  color: gray;
  font-size: 12px;
  line-height: 19px;
  margin-top: 12px;
  padding-right: 10px;
  padding-bottom: 10px;
  justify-content: flex-end;
  white-space: nowrap;
  @media (max-width: 698px) {
    background: white;
    z-index: 2;
    position: absolute;
    right: 9px;
    bottom: 4px;
  }
`

export const Required = styled.div`
  color: ${RED};
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 6px;
  margin-left: 4px;
`

export const Field = styled.div`
  margin-bottom: 20px;
  &[data-top-margin="20px"] {
    margin-top: 20px;
  }
  &.with-border {
    margin-bottom: 0;
    display: flex;
    padding: 22px 28px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    border-radius: 12px;
    border: 1px solid  #D7D1D2;
    background: #FFF;
    @media (max-width: 698px) {
      padding: 16px;
      position: relative;
    }
  }
  > div.editor-container {
    width: 100%;
    margin-top: 18px;
    border-radius: 8px;
    border: 1px solid #D7D1D2;
    background: #FFF;
  }
  && .richTextEditor {
    border: unset !important;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: #625F5F;
  }
  @media (max-width: 698px) {
    .rdw-editor-main {
      min-height: 128px;
    }
  }
`

export const InfoTitle = styled.div`
  display: flex;
  background-color: ${GRAY_LIGHTEST};
  padding: 10px;
  font-weight: 600;
`

export const ReviewContainer = styled.div`
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  flex: 1.5;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const CheckboxLabel = styled.div`
  display: inline-block;
`

export const CheckBoxContainer = styled.div`
  margin-right: 10px;
  flex: 1.2;
  @media (max-width: 768px) {
    flex: 4;
    & .ant-checkbox-wrapper {
      margin: 0 5px 5px 0;
    }
  }
`

export const Title = styled.div`
  margin-right: 20px;
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`

export const ProjectInfoContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 8px;
  @media (max-width: 698px) {
    margin-bottom: 0px;
  }
`

export const ListContainer = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  background: #F7F7F7;
  h6 {
    color: #A8A0A1;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.6px;
    text-transform: uppercase;
  }
  ul {
    padding-inline-start: 24px;
    margin-bottom: 0;
    @media (max-width: 320px) {
      padding-inline-start: 20px;
      font-size: 13px;
      line-height: 18px;
      font-weight: 400;
    }
    li {
      margin-bottom: 6px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  position: relative;
`

export const StyledInput = styled(Input)`
  border: 1px solid ${({ highlight }: DivProps) => highlight ? RED : GRAY_ANTDESIGN};
`

export const QuestionSpan = styled.span`
  height: 24px;
  max-width: 24px;
  width: 100%;
  color: ${GRAY_DARK};
  line-height: 23px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin: 0 7px;
  border: 1px solid ${GRAY_DARK};

  &:hover {
    cursor: pointer;
  }
`

export const MultipleItemsButton = styled.div`
  color: ${BLUE};
  margin-top: 10px;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 698px) {
    visibility: hidden;
  }
`

export const StyledSearch = styled(Search)`
  width: 100%;
`

export const SearchButton = styled(Button)`
  height: 100%;
  border: none;
  width: 35px;
`

export const Products = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  padding-bottom: 0;
  border: 1px solid #f1f4f5;
  &[data-locker-design="true"] {
    padding-inline: 4px;
    border: none;
  }
`

export const EditButton = styled.div`
  color: ${RED};
  align-self: flex-end;
  margin-bottom: 10px;
  cursor: pointer;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  &.project-header {
    background: #F7F7F7;
    padding-top: 10px;
    padding-inline: 10px;
    margin-bottom: 10px;
    margin-inline: 6px;
    @media (max-width: 480px) {
      margin-top: 20px;
    }
  }
  &[data-locker-design="true"] {
    padding-left: 2px;
    padding-right: 8px;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 120px;
  @media (max-width: 768px) {
    flex-direction: row;
    margin: 0;
    width: 100%;
  }
`

export const LockerGrid = styled.div`
  max-width: 446px;
  width: 100%;
  padding-bottom: 38px;
`

export const StrongText = styled.div`
  color: ${GRAY_DARK};
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    width: 50%;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/IntakeForm/Notes/styledComponents.tsx